/**
 * Central configuration file
 * 
 * Switch between localhost development and production by changing IS_PRODUCTION
 * No .env file needed - just edit this file manually
 */

// ============================================
// SWITCH THIS TO TRUE FOR PRODUCTION
// ============================================
export const IS_PRODUCTION = true;

// API Base URL
export const API_BASE_URL = IS_PRODUCTION
  ? 'https://api.ophieliu.com/api'      // Production API endpoint (subdomain)
  : 'http://localhost:3002/api';    // Development API endpoint

// Full base URL (without /api)
export const BASE_URL = IS_PRODUCTION
  ? 'https://ophieliu.com'
  : 'http://localhost:3002';
